import { endOfDay } from 'date-fns';

import { sdpNumber } from '../../common/pipe/single-decimal-point';
import { AxisLeftTick } from '../../scorecard-mi2/chart/axis-left-tick';
import { AxisRightTick } from '../../scorecard-mi2/chart/axis-right-tick';
import { TrendAxisDataAxisPathPointInsight } from '../../scorecard-mi2/trend-dialog/model/trend-axis-data-axis-path-point-insight.model ';
import { Mi2ScoreData } from '../models/mi2-score-data';

import { getLeftTicks } from './get-left-ticks.function';

export function getScorecardChart(
    data: Mi2ScoreData[],
    name: string,
): {
    leftTicks: AxisLeftTick[];
    rightTicks: AxisRightTick[];
    points: TrendAxisDataAxisPathPointInsight[];
} {
    const leftTicks: AxisLeftTick[] = getLeftTicks();

    const points = data
        ?.filter((e) => e.actual != null)
        .map<TrendAxisDataAxisPathPointInsight>((e) => {
            const pd = (e.periodDate as any as string)?.trim()?.toLowerCase();
            return {
                x: endOfDay(
                    pd?.endsWith('z')
                        ? new Date(pd.slice(0, -1))
                        : new Date(pd),
                ),
                y: e.actual / 10,
                color: ' #1e60d4',
                actual: sdpNumber(e?.actual),
                name,
                target: e.target != null ? sdpNumber(e.target) : '-',
                pctToTarget: sdpNumber(e?.pctToTarget),
            };
        })
        .filter((e) => e.y != null && e.y !== 0);

    return { leftTicks, rightTicks: [], points };
}
